import { Switch } from "@/components/switch";

interface ModeSwitchProps {
  isCompletion: boolean;
  onChange?: () => void;
  readonly?: boolean;
  leftLabel?: string;
  rightLabel?: string;
}

const ModeSwitch = ({
  isCompletion,
  onChange,
  readonly,
  leftLabel = "Chat",
  rightLabel = "Completion",
}: ModeSwitchProps) => {
  return (
    <div className="flex select-none items-center">
      <span className="mr-2 text-sm">{leftLabel}</span>
      <Switch checked={isCompletion} disabled={readonly} onChange={onChange} />
      <span className="ml-2 text-sm">{rightLabel}</span>
    </div>
  );
};

export default ModeSwitch;
